module.exports = __webpack_public_path__ + "static/media/gitTogether-home.b56eba51.png";